import { useCallback } from "react";
import { useAuth, useUser } from "@clerk/clerk-react";

/**
 * Hook that returns a stable token-getter function. The returned async
 * function fetches a fresh Clerk JWT for Supabase on each call.
 *
 * Usage:
 *   const fnGetToken = fnUseSupabaseToken();
 *   const sToken = await fnGetToken();  // call before each Supabase op
 */
export const fnUseSupabaseToken = () => {
  const { getToken } = useAuth();

  return useCallback(async (): Promise<string | null> => {
    return getToken({ template: "supabase" });
  }, [getToken]);
};

export { useAuth, useUser };
